<template>
  <div class="login">
    <div class="login_banner">
      <!-- <img class="banner" src="../assets/logo_name.png"> -->
      <h1>{{$t('login.intelligentPositionSystem')}}</h1>
    </div>
    <div class="login-con">
      <div class="err-help" v-if="errInfo">{{$t('login.usernameOrPasswordError')}}</div>
      <AccountLogin @errInfo="getErrInfo"  v-if="loginMode === 'account'"/>
      <PhoneLogin @errInfo="getErrInfo" @ok="clearErrInfo" v-if="loginMode === 'phone'" />
      <div class="select">
        <a-button type="primary" @click="selectLogin" class="select-btn">
          <a-icon v-if="loginMode === 'account'" class="icon"  type="mobile"></a-icon>
          <a-icon v-else class="icon" type="user"></a-icon>
          {{loginMode === 'account' ? $t('login.smsLogin') : $t('login.accountLogin')}}
        </a-button>
      </div>
      <div style="text-align: center">
          <a-radio-group name="radioGroup" :defaultValue="locale"   @change="changeLocale">
              <a-radio value="zh-cn">{{$t('global.chinese')}}</a-radio>
              <a-radio value="en">{{$t('global.english')}}</a-radio>
              <a-radio value="ru">{{$t('global.russian')}}</a-radio>
          </a-radio-group>
      </div>
      <div class="beian">
        <a href="https://beian.miit.gov.cn" target="_blank">{{ $t('login.beian')}}</a>
      </div>
    </div>
  </div>
</template>
<script>
import config from '../config'
import AccountLogin from './AccountLogin'
import PhoneLogin from './PhoneLogin'
import {mapActions, mapState} from 'vuex'
export default {
  data() {
    return {
      loginMode: 'account',
      errInfo: '',
    }
  },
  computed: {
    ...mapState({
      locale: state => state.lang
    })
  },
  methods: {
    ...mapActions(['setLang']),
    changeLocale(event){
      // console.log(event)
      let lang = event.target.value
      this.$moment.locale(lang)
      this.setLang(lang)
      // localStorage.setItem('locale', this.locale)
      this.$i18n.locale = lang
    },
    getErrInfo (e) {
      this.errInfo = e
    },
    clearErrInfo () {
      this.errInfo = ''
    },
    selectLogin () {
      // console.log(1)
      this.errInfo = ''
      if (this.loginMode === 'account') {
        this.loginMode = 'phone'
        // console.log(this.loginMode)
      } else {
        this.loginMode = 'account'
      }
    }
  },
  components: {
    AccountLogin,
    PhoneLogin
  }
}
</script>
<style lang="less" scoped>
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background: url('../assets/full_banner.png') no-repeat center center fixed;
  background-size: 100%;
  // background-color: rgb(235, 234, 232);
  .login_banner {
    .banner {
      width: 100%;
    }
    h1{
        font-weight: bold;
        color: #fff;
        margin-left: 10px;
        font-size: 30px;
      }
  }
  
  .login-con {
    // background-color: #fff;
    margin-top: 30px;
    box-shadow: 1px 1px 5px rgb(92, 91, 91);
    padding: 20px 20px 10px 20px;
    border-radius: 10px;
    // position: fixed;
    background-color: rgba(255, 255, 255, 0.9);
    // top: 30%;
    .beian {
      position: fixed;
      left: 46%;
      bottom: 20px;
      text-align: center;
      margin-top: 10px;
      a {
        color: #ccc;
        &:hover {
          color: #fff
        }
      }
    }
    .err-help {
      color: red;
    }
    .select {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 1px solid rgb(168, 167, 167);
      // margin: 0 24px;
      margin-top: 10px;
      padding: 10px 0;
      .select-btn {
        width: 100%;
        // background-color: rgb(138, 74, 54);
        color: rgb(244, 246, 248);
        line-height: 20px;
      }
      .icon {
        font-size: 20px;
        color: rgb(244, 246, 248);
        cursor: pointer;
      }
    }
  }
}
</style>